import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter, HostListener, Inject,
  Input, OnChanges, OnInit,
  Output
} from "@angular/core";
import {PositionAlign} from "satellite-droparea";
import {Positions} from "satellite-droparea/dist/core/base/types";
import {BehaviorSubject} from "rxjs";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'int-target-dropdown',
  templateUrl: './int-target-dropdown.component.html',
  styleUrls: ['./int-target-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntTargetDropdownComponent implements OnChanges, OnInit {
  @Input() dropdownHeight = '10rem';
  @Input() dropdownWidth: number | null = null;
  @Input() set show(status: boolean) {
    this.show$.next(status);
  };
  @Input() positions: Array<Positions> = ['bottom'];
  @Input() verticalAlign: PositionAlign = "center";
  @Input() horizontalAlign: PositionAlign ='center';
  @Input() verticalOffset: number = 0;
  @Input() horizontalOffset: number = 0;
  @Input() viewportOffset: number = 0;
  @Input() hideIsNotVisible = true;
  @Input() stopPropagation = false;
  @Input() dropAreaZIndex = 100;
  @Input() viewportRef: HTMLElement | null = this.DocumentRef.documentElement;

  @Input() dropAreaStyles: {[key: string]: string} = {};

  @Input() hideSignal: ((toggle: Function) => void) | null = null;

  @Output() targetNotVisible = new EventEmitter();
  @Output() dropVisibleStatusEvent = new EventEmitter<boolean>();

  show$ = new BehaviorSubject(this.show);

  constructor(
    private readonly cdr: ChangeDetectorRef,
    @Inject(DOCUMENT)
    private readonly DocumentRef: Document,
  ) {}

  ngOnChanges(changes: any) {
    this.cdr.detectChanges();
  }

  ngOnInit() {
    if(this.hideSignal !== null) {
      this.hideSignal(this.hide.bind(this));
    }
  }

  get dropStyles() {
    return {
      '--int-dropdown-area-max-height': this.dropdownHeight,
      '--int-dropdown-area-z-index': this.dropAreaZIndex,
      ...this.dropAreaStyles
    }
  }

  get options() {
    return {
      positionSteps: this.positions,
      customDropWidth: this.dropdownWidth,
      verticalAlign: this.verticalAlign,
      horizontalAlign: this.horizontalAlign,
      verticalOffset: this.verticalOffset,
      horizontalOffset: this.horizontalOffset,
      viewportOffset: this.viewportOffset
    }
  }

  hide() {
    this.show$.next(false);
    this.cdr.markForCheck();
  }

  @HostListener('click', ['$event'])
  toggle(e?: Event) {
    if(e && this.stopPropagation) {
      e.stopPropagation();
    }
    this.show$.next(!this.show$.value);
    this.dropVisibleStatusEvent.emit(this.show$.value);
    this.cdr.markForCheck();
  }

  targetIsNotVisible() {
    if(this.hideIsNotVisible) {
      this.toggle();
    }
    this.targetNotVisible.emit();
  }
}
